import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import styles from './index.pcss';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { getFeatureVariant } from '../../organism/ABFeature/Feature';
import { getShowRateProdBtn } from '../../selectors/featureFlagsSelector';

const isSignedIn = signInCheck();

const cx = classNames.bind(styles);
const mapStateToProps = state => ({
  showRateProdBtn: getShowRateProdBtn(state?.flags)
});
const connector = connect(mapStateToProps);

const UnrateItemsDesktop = (props: any) => {
  const { rateProductModal, isRating, isCustomerWord, btnCta = 'Rate this Product' } = props;
  const rateProdBtnVariant = getFeatureVariant('showRateProdBtnSection') || '0';
  const isWriteAReview = btnCta.toLowerCase() === 'write a review';
  return !isRating ? (
    <div className={cx('unrated-items-desktop')}>
      <div className={cx('unrated-text')}>
        <ul
          className={cx('No-rating-or-review-to-display-Be-the-first-one-to-review-this-product')}
        >
          <li>No rating or review to display. </li>
        </ul>
      </div>
      {isSignedIn && rateProdBtnVariant === '1' && (
        <div className={cx('rate-btn-section')}>
          <div className={cx('rate-this-product')}>
            <p className={cx('rate-this-btn')} onClick={() => rateProductModal(isWriteAReview)}>
              {btnCta.toUpperCase()}
            </p>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div>
      {isSignedIn && rateProdBtnVariant === '1' && (
        <div
          className={cx(
            'rate-this-product',
            isCustomerWord ? 'customer-opinion-avail' : 'customer-opinion-no-avail'
          )}
        >
          <p className={cx('rate-this-btn')} onClick={() => rateProductModal(isWriteAReview)}>
            {btnCta.toUpperCase()}
          </p>
        </div>
      )}
    </div>
  );
};

export default connector(UnrateItemsDesktop);
